import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import { trackTechInspectionButtonClick } from './tracking';
import { useApplicationContext } from '../ApplicationContext';

export const SuburbanTechInspectionButtonContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const techInspectionLink = config.get<string>('headerFrontend.suburbanTechInspectionLink');

  if (!techInspectionLink) {
    return null;
  }

  return (
    <LinkButton
      href={techInspectionLink}
      target="_blank"
      theme="stroke_primary"
      size="XS"
      onClick={trackTechInspectionButtonClick}
    >
      Проверить состояние
    </LinkButton>
  );
};
